module.exports = __webpack_public_path__ + "static/img/online_competition.00c4968.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/online_competition.png
// module id = Q4k5
// module chunks = 1